export const APP_TAG_KEY = 'appname'
export const WINDOW_TAG_KEY = 'content-category'

export const PROCESS_ID_REGEX_URL_PATH_START = '(?<='
export const PROCESS_ID_REGEX_URL_PATH_END = ')(.*?)(?=[?/]|$)'
export const PROCESS_ID_REGEX_TITLE_START = '(?<='
export const PROCESS_ID_REGEX_TITLE_END = ')(.+?)(?=[\\s+]|$)'
